<template>
  <Box ref="container" class="bg-white/90 p-5" rounded="lg">
    <div class="flex items-center justify-between">
      <h4
        class="font-Kontesa text-[28px] font-bold uppercase leading-none tracking-tight text-navy"
      >
        Impact
      </h4>

      <Box
        v-if="!hideActions"
        class="h-10 w-10 bg-[#F1EBFF]"
        rounded="full"
        border="lg"
      >
        <button
          type="button"
          class="flex h-full w-full items-center justify-center"
        >
          <IconsShare class="h-5 w-5" />
        </button>
      </Box>
    </div>

    <div class="my-5 border-b border-dashed border-navy" />

    <div class="space-y-8">
      <ProfileImpactStat
        ref="trees"
        type="trees"
        :amount="metrics.trees"
        :previous-amount="previousMetrics?.trees"
        @animation-end="ocean?.playAnimation"
      >
        <ProfileDonateMoreDialog
          v-if="!hideActions"
          :default-campaign="Campaign.TFTF"
          :trigger-open="donateMore === 'trees'"
          @donate="onDonate"
        />
      </ProfileImpactStat>
      <ProfileImpactStat
        ref="ocean"
        type="ocean"
        :amount="metrics.ocean"
        :previous-amount="previousMetrics?.ocean"
        @animation-end="education?.playAnimation"
      >
        <ProfileDonateMoreDialog
          v-if="!hideActions"
          :default-campaign="Campaign.PF"
          :trigger-open="donateMore === 'ocean'"
          @donate="onDonate"
        />
      </ProfileImpactStat>
      <ProfileImpactStat
        ref="education"
        type="education"
        :amount="metrics.education"
        :previous-amount="previousMetrics?.education"
        @animation-end="seagrass?.playAnimation"
      >
        <ProfileDonateMoreDialog
          v-if="!hideActions"
          :default-campaign="Campaign.SARTHAK"
          :trigger-open="donateMore === 'education'"
          @donate="onDonate"
        />
      </ProfileImpactStat>
      <ProfileImpactStat
        ref="seagrass"
        type="seagrass"
        :amount="metrics.seagrass"
        :previous-amount="previousMetrics?.seagrass"
        @animation-end="$emit('animation-end')"
      >
        <ProfileDonateMoreDialog
          v-if="!hideActions"
          :default-campaign="Campaign.REEFGEN"
          :trigger-open="donateMore === 'seagrass'"
          @donate="onDonate"
        />
      </ProfileImpactStat>
    </div>
  </Box>
</template>

<script setup lang="ts">
import ProfileImpactStat from "@/components/Profile/Impact/Stat.vue";
import { Campaign } from "~/lib/campaigns";

type MetricType = "ocean" | "education" | "trees" | "seagrass";
type Metrics = Record<MetricType, number>;
defineProps<{
  metrics: Metrics;
  previousMetrics?: Metrics;
  hideActions?: boolean;
  donateMore?: MetricType;
}>();

const emit = defineEmits<{
  (e: "animation-end" | "donate"): void;
}>();

const container = ref<HTMLElement | null>(null);
const trees = ref<InstanceType<typeof ProfileImpactStat> | null>(null);
const ocean = ref<InstanceType<typeof ProfileImpactStat> | null>(null);
const education = ref<InstanceType<typeof ProfileImpactStat> | null>(null);
const seagrass = ref<InstanceType<typeof ProfileImpactStat> | null>(null);

function playAnimation() {
  trees.value?.playAnimation();
}

function onDonate() {
  emit("donate");
}

defineExpose({
  playAnimation,
});
</script>
